<template>
    <div>
        <vue-headful :title="this.type.product_type_name + ' [Delete Product Types] - AMOS365'" />

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/admin/settings#product_types">Settings</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Delete: {{ type.product_type_name }}</li>

            </ol>
        </nav>

        <h4 class="page-header">
            <span>Delete: {{ type.product_type_name }}</span>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="alert alert-danger">
                            <strong>Warning:</strong> You are about to permanently delete this Product Type. This cannot be undone.

                            <p v-if="in_use > 0">
                                Product Type: {{ type.product_type_name }} is currently in use on {{ in_use }} product(s). Select a replacement product type to assign to these products.
                            </p>
                        </div>
                        <div class="row mb-3" v-if="in_use > 0">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.other_product_type_id, 'text-muted-no': !errors.other_product_type_id}">
                                Replacement Product Type: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-select v-model="other_product_type_id" :options="otherOptions" :class="{'is-invalid': errors.contract_status_id}" />

                                <div class="text-danger mt-1" v-if="errors.other_product_type_id">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.other_product_type_id">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-danger" v-on:click="postSave()" :disabled="deleting">
                    <template v-if="deleting"><i class="fa fa-spinner fa-spin"></i> Deleting</template>
                    <template v-else>Delete Product Type</template>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                errors: {},
                type: {},
                other_product_type_id: null,
                in_use: null,
                others: [],
            }
        },

        watch: {

        },

        computed: {
            otherOptions(){
                //Setup
                var options = [{value: null, text: '-- Select Replacement Product Type --'}];

                //Main Loop
                for(var i = 0; i < this.others.length; i++)
                {
                    //Push
                    options.push({value: this.others[i].id, text: this.others[i].product_type_name});
                }

                //Send it
                return options;
            },
        },

        methods: {
            getData(){
                //Send it
                this.$http.get('/admin/product-types/'+this.id+'/delete')
                    .then(response => {
                        //Set Data
                        this.type = response.data.type;

                        //Setup
                        this.in_use = response.data.in_use;

                        //Other Product Types
                        this.others = response.data.others;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postSave(){
                //Set
                this.deleting = true;

                //Send it
                this.$http.post('/admin/product-types/'+this.id+'/delete', {other_product_type_id: this.other_product_type_id})
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Product Type Deleted');

                        //Set Back to Settings
                        this.$router.push('/admin/settings#product_types');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getData();
        }
    }
</script>